export default __webpack_public_path__ + "static/media/exchange logo_green 5.086817a0.svg";